import AsyncStorage from '@react-native-community/async-storage';
 
export const setStorage = async (key: any, items: any) => {
  try {
    await AsyncStorage.setItem(key, JSON.stringify(items));
  } catch (error) {
    console.info(error);
  }
};
 
export const getStorage = async (key: any) => {
  try {
    const retrievedItem = await AsyncStorage.getItem(key);
 
    if (retrievedItem != null) {
      return JSON.parse(retrievedItem);
    }
 
    return null;
  } catch (error) {
    console.info(error);
    return null;
  }
};
 
export const mergeStorage = async (key: any, items: any) => {
  try {
    await AsyncStorage.mergeItem(key, JSON.stringify(items));
  } catch (error) {
    console.info(error);
  }
};
 
export const removeStorage = async (key: any) => {
  try {
    await AsyncStorage.removeItem(key);
  } catch (error) {
    console.info(error);
  }
};